import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActiveUserStore } from '../stores/user/active-user.state';
import { GlobalsStore } from '../stores/globals.state';

@Injectable()
export class MetaIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const userStore = inject(ActiveUserStore);
    // Retrieve the user ID from the UserService
    const userId = userStore.user()?._id;
    let context = userStore.context();
    // overwrite meta-guestView to atlasExternal hook
    if (context === 'guestView') context = 'atlasInternal';

    if (userId) {
      const communeId = userStore.commune();

      const authReq = req.clone({
        withCredentials: true,
        setHeaders: {
          'X-User-ID': userId,
          'X-Commune-ID': communeId,
          'X-Context': context || '',
          // Use `setHeaders` to add/override the existing headers without overwriting all
        },
      });

      // Pass on the cloned request instead of the original request
      return next.handle(authReq);
    } else {
      const communeId = userStore.commune() || '';

      const openReq = req.clone({
        withCredentials: true,
        setHeaders: {
          'X-User-ID': '',
          'X-Commune-ID': communeId,
          'X-Context': context || '',
          // Use `setHeaders` to add/override the existing headers without overwriting all
        },
      });
      return next.handle(openReq);
    }
  }
}
